import { Dialog } from '@medely/web-components';
import { useCurrentUser } from '@mp/hooks';
import React from 'react';
import { ExperienceSummaryResumeModalProps } from './interface';
import { ExperienceSummaryResumeInfo } from './ExperienceSummaryResumeInfo';

export const ExperienceSummaryResumeModal = ({
  open,
  onClose,
}: ExperienceSummaryResumeModalProps) => {
  const { currentUser } = useCurrentUser();
  const resume = currentUser?.professional?.resume;

  return (
    <Dialog
      open={open}
      disableRestoreFocus
      title={!!resume ? `Replace resume` : 'Upload resume'}
      content={<ExperienceSummaryResumeInfo onClose={onClose} />}
    />
  );
};
